import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    textAlign: 'left'
  },
}));

export default (props) => {
  const classes = useStyles();

  return (
    <Paper
      variant="outlined"
      {...props}
      className={clsx(classes.paper, props.className)}
    >
      {props.children}
    </Paper>
  );
};